import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './components/app.jsx'
import '../styles.css'

ReactDOM.createRoot(document.getElementById('root')).render(<App />)
